import { Component, ViewChild } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import {
  ButtonsModule,
  IconModule,
  LoadingService,
  ModalModule,
  RadioButtonModule,
} from 'axis-components';
import { Logger } from '../../_core/logger.service';
import { PdfService } from '../../_services/pdf/pdf.service';
import { FormType } from '../../config/constants';
import { NotificationService } from '../../_services/notification/notification.service';
@Component({
  selector: 'app-modal-uimui-review-form',
  templateUrl: './modal-uimui-review-form.component.html',
  standalone: true,
  imports: [ButtonsModule, IconModule, ModalModule, RadioButtonModule],
})
export class ModalUIMUIReviewFormComponent {
  reviewStates: any[] = [];
  selectedStateIndex = 0;
  iframeUrl;
  any;
  electronicConsent: boolean = true;

  constructor(
    private pdfService: PdfService,
    private sanitizer: DomSanitizer,
    private loadingService: LoadingService,
    private notificationService: NotificationService,
  ) {}
  /* properties */
  modalleftSidebarClosed = false;
  @ViewChild('modalUIMUIReviewForm') modalUIMUIReviewForm;
  /* methods */
  open(): void {
    //this.modalUIMUIReviewForm.open();
    Logger.log('UIMUI Review Form Modal opened');
    setTimeout(() => {
      this.getReviewStateForm(FormType.UM_UIM);
    }, 100);
  }

  getReviewStateForm(formType) {
    Logger.log(`Start of review UM UIM State forms with electronicConsent=${this.electronicConsent}`);
    this.loadingService.start();
    this.pdfService.getReviewStateForm(formType, this.electronicConsent).subscribe({
      next: (response) => {
        this.loadingService.stop();
        const blob = new Blob([response], { type: 'text/html' });
        const url = window.URL.createObjectURL(blob);
        window.open(url, '_blank', 'noopener,noreferrer');
        //this.iframeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
      },
      error: (err) => {
        this.loadingService.stop();
        console.error('Error generating PDF:', err);
        this.notificationService.showNotification(
            'The forms you are trying to download are currently unavailable. Please try again later.',
            'error',
          );
      },
    });
  }

  ngOnInit() {}

  selectState(index: number): void {
    this.selectedStateIndex = index;
  }
}
